// extracted by mini-css-extract-plugin
module.exports = {"fotorama":"a10a3f92e9--fotorama--3VPYn","fotorama-counter":"a10a3f92e9--fotorama-counter--Y7KVD","default_content":"a10a3f92e9--default_content--23yVZ"};